import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Next from '@/components/Next.vue';
let LanguageSelector = class LanguageSelector extends Vue {
    constructor() {
        super(...arguments);
        this.localizationOptions = this.$store.state.menu
            ? this.$store.state.menu.localizations.sort((c, n) => c.order - n.order)
            : [];
    }
    select(language, currency = '') {
        this.$store.dispatch('changeCurrency', currency);
        this.$store.dispatch('changeLanguage', language);
        this.$emit('select');
    }
};
LanguageSelector = __decorate([
    Component({
        components: {
            Next
        }
    })
], LanguageSelector);
export default LanguageSelector;
